import { Content as AccordionContent } from "@radix-ui/react-accordion";
import { type ComponentProps } from "react";

import { cn } from "../../utils";

export const Content = ({ ref, className, children, ...props }: ComponentProps<typeof AccordionContent>) => (
  <AccordionContent
    ref={ref}
    className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn(className)}>{children}</div>
  </AccordionContent>
);

Content.displayName = AccordionContent.displayName;

export default Content;
